<template>
  <article class="product-card" @mouseenter="stopImageCarousel" @mouseleave="startImageCarousel" @click="$emit('select', product)">
    <div class="product-card__image image-frame" :class="{ 'image-frame--fallback': imageFailed }">
      <img v-if="displayImage && !imageFailed" :key="displayImage" :src="displayImage" :alt="product.name || $store.getters.t('product')" @error="imageFailed = true">
      <span v-else>{{ product.name || $store.getters.t('product') }}</span>
    </div>
    <div class="product-card__body">
      <h3>{{ product.name || $store.getters.t('product') }}</h3>
      <p>{{ productDescription }}</p>
      <button type="button" class="button button-dark" @click.stop="$emit('select', product)">{{ $store.getters.t('viewDetails') }}</button>
    </div>
  </article>
</template>

<script>
import { formatCopyText } from '../utils/copyText'

export default {
  name: 'ProductCard',
  props: {
    product: { type: Object, required: true },
    image: { type: String, default: '' }
  },
  data () {
    return {
      imageFailed: false,
      imageIndex: 0,
      imageTimer: null
    }
  },
  computed: {
    images () {
      const list = []
      const append = item => {
        const url = typeof item === 'string' ? item : item && (item.imageUrl || item.image_url || item.url)
        if (url && !list.includes(url)) list.push(url)
      }
      append(this.product.coverImage)
      ;(this.product.images || []).forEach(append)
      return list
    },
    displayImage () {
      return this.image || this.images[this.imageIndex] || this.product.coverImage || ''
    },
    productDescription () {
      // 句首大写、其余小写；车型名 / 型号保持大写（不再靠 CSS capitalize）
      return formatCopyText(
        this.formatMultilineText(this.product.description || this.product.summary || ' '),
        [this.product.name, this.product.subtitle, this.product.model]
      )
    }
  },
  mounted () { this.startImageCarousel() },
  beforeDestroy () { this.stopImageCarousel() },
  watch: {
    displayImage () { this.imageFailed = false },
    image () {
      this.imageIndex = 0
      this.imageFailed = false
      this.startImageCarousel()
    },
    product () {
      this.imageIndex = 0
      this.imageFailed = false
      this.startImageCarousel()
    }
  },
  methods: {
    nextImage () {
      if (this.image || this.images.length < 2) return
      this.imageIndex = (this.imageIndex + 1) % this.images.length
    },
    formatMultilineText (value) {
      return String(value || '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\\n/g, '\n')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n[ \t]+/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
    },
    startImageCarousel () {
      this.stopImageCarousel()
      if (!this.image && this.images.length > 1) {
        this.imageTimer = window.setInterval(this.nextImage, 3000)
      }
    },
    stopImageCarousel () {
      if (this.imageTimer) window.clearInterval(this.imageTimer)
      this.imageTimer = null
    }
  }
}
</script>
